module.exports = __webpack_public_path__ + "img/card-2.495f72b9.png";